import React, { useState } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledBox = styled(Box)`
  background: #EFEFEFCC;
  min-height: 158px;
  padding: 24px 24px 24px 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.opacity-80 {
    background-color: rgba(239 239 239 / 80%);
  }

  &.opacity-60 {
    background-color: rgba(239 239 239 / 60%);
  }

  &.opacity-40 {
    background-color: rgba(239 239 239 / 40%);
  }

  &.opacity-30 {
    background-color: rgba(239 239 239 / 30%);
  }

  &.opacity-full-purple {
    background-color: #7B4DD6;

    #collapse-icon img {
      filter: invert(1);
    }
  }
`;

const StyledRowTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  line-height: 23.4px;
  letter-spacing: -0.01em;
  text-align: left;
`;

const StyledHorizontalLine = styled(Box)`
  border: ${props => (props.color === true ? '1px solid #f4e7ff36;' : '1px solid #1111111A;')};
  width: 60px;
  height: 1px;
`;

const StyledRowSubtitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: -0.01em;
  text-align: left;
  width: 60%;
`;

const StyledRowPercentage = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  letter-spacing: -0.01em;
  padding: 4px 8px;
  border-radius: 5px;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  height: 100%;
`;

const StyledGatTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-bottom: 8px;
`;

const StyledGatsubtitle = styled(Typography)`
  font-size: 13px;
  font-style: italic;
  font-weight: 400;
  line-height: 15.6px;
  text-align: left;
  width:60%;
`;

const StyledGatPercentage = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  letter-spacing: -0.01em;
  text-align: center;
`;

function MobileYieldBox({
  days, percentage, gatNominal, gatReal, className, highlighted, appendRateDisclaimerAsterisk,
}) {
  const [isCollapsed, setCollapsed] = useState(false);

  const renderCajitaType = time => {
    switch (time) {
      case 0:
        return (
          <StyledRowTitle strong>
            Cajitas Nu
            <sup>²</sup>
          </StyledRowTitle>
        );
      case 1:
        return (
          <StyledRowTitle color="white" strong>
            Cajita Turbo
            <sup>¹</sup>
          </StyledRowTitle>
        );
      default:
        return (
          <div>
            <StyledRowTitle strong color={highlighted ? 'white' : 'black'}>Ahorro Congelado</StyledRowTitle>
            <StyledRowTitle color={highlighted ? 'white' : '#7B4DD6F5'} strong>
              {`${time} días`}
              <sup>³</sup>
            </StyledRowTitle>
          </div>
        );
    }
  };

  return (
    <StyledBox marginTop={{ xs: '32px', lg: '40px' }} className={className} onClick={() => setCollapsed(!isCollapsed)}>
      {/* top */}
      <Box display="flex" justifyContent="space-between">
        { renderCajitaType(days) }

        <Box alignSelf="center" id="collapse-icon">
          <Image
            alt="icono"
            src={`${isCollapsed ? 'cuenta/transparency/minus.svg' : 'cuenta/transparency/plus.svg'}`}
            width={isCollapsed ? '9px' : '12px'}
            webp
          />
        </Box>
      </Box>

      {/* middle/separator */}

      <Box display="flex" alignItems="center">
        <Box marginLeft="-60px">
          <Image
            alt="icono de ahorro congelado"
            src={`${days <= 1 ? 'cuenta/transparency/cajita.svg' : 'cuenta/transparency/frozen.svg'}`}
            width="46px"
            webp
          />
        </Box>

        <StyledHorizontalLine color={highlighted} marginLeft="16px" />
      </Box>

      {/* bottom */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <StyledRowSubtitle whiteSpace="pre-line" strong color={highlighted ? 'white' : 'black'}>
          {'Tasa de '}
          <StyledRowSubtitle strong tag="span" color={highlighted ? 'white' : 'primary'}>
            Rendimiento
          </StyledRowSubtitle>
          {' \n Anual Fija'}
        </StyledRowSubtitle>
        {
          percentage
            ? (
              <StyledRowPercentage
                tag="span"
                strong
                backgroundColor={highlighted ? 'white' : '#7B4DD6'}
                textColor={highlighted ? '#7B4DD6' : 'white'}
              >
                {`${percentage}%`}
                {appendRateDisclaimerAsterisk && '*'}
              </StyledRowPercentage>
            )
            : null
        }

      </Box>

      {/* const StyledRowPercentageInverted = styled(Typography)`
  padding: 4px 8px;
  padding-bottom: 4px;
  border-radius: 5px;
  background-color: white;
  color: #7B4DD6;
  font-size: 24px;
  font-weight: 500;
  line-height: 28.8px;
  letter-spacing: -0.02em;
`; */}
      {/* COLLAPSED CONTENT */}

      { isCollapsed ? (
        <Box
          marginTop="24px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >

          <StyledHorizontalLine color={highlighted} marginBottom="14px" />

          <Box display="flex" marginBottom="24px" justifyContent="space-between">
            <div>
              <StyledGatTitle strong color={highlighted ? 'white' : 'black'}>GAT Nominal</StyledGatTitle>
              <StyledGatsubtitle color={highlighted ? 'white' : 'black'}>
                Es el porcentaje de rendimiento antes de impuestos.
              </StyledGatsubtitle>
            </div>

            <Box alignSelf="center">
              <StyledGatPercentage strong color={highlighted ? 'white' : 'black'}>{`${gatNominal}%`}</StyledGatPercentage>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between">
            <div>
              <StyledGatTitle strong color={highlighted ? 'white' : 'black'}>GAT Real</StyledGatTitle>
              <StyledGatsubtitle color={highlighted ? 'white' : 'black'}>
                Es el rendimiento que obtendría después de descontar la inflación estimada.
              </StyledGatsubtitle>
            </div>

            <Box alignSelf="center">
              <StyledGatPercentage strong color={highlighted ? 'white' : 'black'}>{`${gatReal}%`}</StyledGatPercentage>
            </Box>
          </Box>
        </Box>
      ) : null}
    </StyledBox>

  );
}

MobileYieldBox.defaultProps = {
  appendRateDisclaimerAsterisk: false,
  className: {},
  days: 0,
  highlighted: false,
};

MobileYieldBox.propTypes = {
  appendRateDisclaimerAsterisk: PropTypes.bool,
  className: PropTypes.string,
  days: PropTypes.number,
  gatNominal: PropTypes.string.isRequired,
  gatReal: PropTypes.string.isRequired,
  highlighted: PropTypes.bool,
  percentage: PropTypes.string.isRequired,
};

export default MobileYieldBox;
